import { Bot, Check, Wrench, ShieldCheck } from "lucide-react";

const TRACE = [
    { t: "Intent", v: "Classify HR leave-policy request", tool: "reasoning" },
    { t: "Tool call", v: "hr_policy.search('parental leave')", tool: "retrieval" },
    { t: "Tool call", v: "workday.get_balance(emp_id)", tool: "system" },
    { t: "Guardrail", v: "Policy check passed · within entitlement", tool: "policy" },
    { t: "Action", v: "Drafted response + filed ticket #4821", tool: "write" },
];

/**
 * Reusable "AgentIQX" agent-run / trace mockup.
 */
export default function AgentRunPanel({ className = "" }) {
    return (
        <div
            className={`rounded-2xl bg-white border border-[#303030]/10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.55)] overflow-hidden ${className}`}
            data-testid="mockup-agent-run"
            aria-hidden="true"
        >
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#303030]/8 bg-[#FAFAF8]">
                <div className="flex items-center gap-2">
                    <span className="w-6 h-6 grid place-items-center rounded-md bg-[#FF4040]/12 text-[#FF4040]">
                        <Bot className="w-3.5 h-3.5" />
                    </span>
                    <span className="text-[12px] font-semibold text-[#303030]">AgentIQX · Run trace</span>
                </div>
                <span className="inline-flex items-center gap-1 font-mono text-[10px] text-[#FF4040] font-semibold">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FF4040] pqx-anim-blink" /> acting
                </span>
            </div>

            <ol className="relative px-4 py-3 space-y-3">
                <span className="absolute left-[27px] top-5 bottom-5 w-px bg-[#303030]/10" />
                {TRACE.map((s, i) => (
                    <li key={i} className="relative flex gap-3 pqx-pop-in" style={{ animationDelay: `${i * 130}ms` }}>
                        <span className="relative z-10 w-6 h-6 grid place-items-center rounded-full bg-[#FF4040] text-white shrink-0">
                            {s.tool === "policy" ? <ShieldCheck className="w-3 h-3" /> :
                             s.tool === "write" ? <Check className="w-3 h-3" /> :
                             <Wrench className="w-3 h-3" />}
                        </span>
                        <div className="flex-1 min-w-0">
                            <p className="text-[10px] uppercase tracking-[0.14em] text-[#303030]/50">{s.t}</p>
                            <p className="text-[12px] font-medium text-[#303030] font-mono truncate">{s.v}</p>
                        </div>
                    </li>
                ))}
            </ol>

            <div className="px-4 py-2.5 border-t border-[#303030]/8 flex items-center gap-1.5 bg-[#FAFAF8]">
                <ShieldCheck className="w-3.5 h-3.5 text-[#FF4040]" />
                <span className="text-[11px] text-[#303030]/60">Policy-aware · human approval gate ready</span>
            </div>
        </div>
    );
}
